import {Injectable} from '@angular/core';
import {RouterService} from '@npck/libs/commons';
import {TableEvent} from '../components/full-table/full-table.component';
import {FraudReportDetailsTab, FraudReportDetailsTabState} from '../pages/analytics/fraud-reports/details/fraud-report-details.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class FraudReportDetailsFilterHolderService {
    private stateByFraudReport: Record<string, Partial<Record<FraudReportDetailsTab, FraudReportDetailsTabState>>> = {};

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.ANALYTICS)) {
                    this.clear();
                }
            });
    }

    getState(fraudReportId: string, tab: FraudReportDetailsTab): FraudReportDetailsTabState | undefined {
        return this.stateByFraudReport[fraudReportId]?.[tab];
    }

    storeTableState(fraudReportId: string, tab: FraudReportDetailsTab, tableEvent: TableEvent): FraudReportDetailsTabState {
        this.stateByFraudReport[fraudReportId] = this.stateByFraudReport[fraudReportId] ?? {};
        const newState: FraudReportDetailsTabState = {
            tableEvent: {...tableEvent, filter: {...tableEvent.filter}},
        };
        this.stateByFraudReport[fraudReportId][tab] = newState;
        return newState;
    }

    clear(): void {
        this.stateByFraudReport = {};
    }
}
